/**
 * Obuna tugaganidan keyin 1 kun o‘tgan, lekin to‘lov hali qayta tiklanmagan.
 * Tugash sanasi bo‘lmasa — darhol qulflash (grace hisoblanmaydi).
 */
export function isSubscriptionPastGraceDay(sub: {
  isExpired: boolean;
  endsAt: string | null;
} | null): boolean {
  if (!sub?.isExpired) return false;
  const raw = sub.endsAt;
  if (raw == null || String(raw).trim() === '') return true;
  const end = new Date(String(raw));
  if (Number.isNaN(end.getTime())) return true;
  const ms = Date.now() - end.getTime();
  return ms >= 24 * 60 * 60 * 1000;
}
